import ChevronLeft from '@assets/icons/chevron-left.svg';
import ChevronRight from '@assets/icons/chevron-right.svg';
import React, { useRef } from 'react';
import { LinearGradient } from 'expo-linear-gradient';
import {
  StyleProp,
  StyleSheet,
  TouchableOpacity,
  ViewStyle,
} from 'react-native';
import { useHover } from 'react-native-web-hooks';
import { useTheme } from '@/contexts/theme-context';

export const arrowWidth = 32;

interface Props {
  activeIndex: number;
  backgroundColor: string;
  buttonContainerStyle?: StyleProp<ViewStyle>;
  count: number;
  onChange: (index: number) => void;
}

export const NavigationArrows: React.FC<Props> = ({
  activeIndex,
  buttonContainerStyle,
  count,
  onChange,
  backgroundColor,
}) => {
  const theme = useTheme();

  const leftButtonRef =
    useRef<React.ComponentRef<typeof TouchableOpacity>>(null);
  const rightButtonRef =
    useRef<React.ComponentRef<typeof TouchableOpacity>>(null);
  const isLeftButtonHovered = useHover(leftButtonRef);
  const isRightButtonHovered = useHover(rightButtonRef);

  return (
    <>
      <LinearGradient
        colors={[backgroundColor, `${backgroundColor}00`]}
        end={[1, 0.5]}
        locations={[0.9, 1]}
        start={[0, 0.5]}
        style={[
          styles.buttonContainer,
          styles.buttonContainerLeft,
          buttonContainerStyle,
          activeIndex > 0 ? null : styles.buttonContainerHidden,
        ]}
      >
        <TouchableOpacity
          onPress={() => onChange(activeIndex - 1)}
          ref={leftButtonRef}
          style={[
            styles.button,
            isLeftButtonHovered ? styles.buttonHovered : null,
            activeIndex > 0 ? null : styles.buttonHidden,
          ]}
          testID="previous-button"
        >
          <ChevronLeft fill={theme.colors.primary} height={20} width={12} />
        </TouchableOpacity>
      </LinearGradient>
      <LinearGradient
        colors={[`${backgroundColor}00`, backgroundColor]}
        end={[1, 0.5]}
        locations={[0, 0.1]}
        start={[0, 0.5]}
        style={[
          styles.buttonContainer,
          styles.buttonContainerRight,
          buttonContainerStyle,
          activeIndex < count - 1 ? null : styles.buttonContainerHidden,
        ]}
      >
        <TouchableOpacity
          onPress={() => onChange(activeIndex + 1)}
          ref={rightButtonRef}
          style={[
            styles.button,
            isRightButtonHovered ? styles.buttonHovered : null,
            activeIndex < count - 1 ? null : styles.buttonHidden,
          ]}
          testID="next-button"
        >
          <ChevronRight fill={theme.colors.primary} height={20} width={12} />
        </TouchableOpacity>
      </LinearGradient>
    </>
  );
};

export const styles = StyleSheet.create({
  button: {
    alignItems: 'center',
    justifyContent: 'center',
    opacity: 0.6,
    padding: 8,
  },
  buttonContainer: {
    bottom: 0,
    justifyContent: 'center',
    position: 'absolute',
    top: 0,
    width: arrowWidth,
  },
  buttonContainerHidden: {
    display: 'none',
  },
  buttonContainerLeft: {
    alignItems: 'flex-start',
    left: 0,
  },
  buttonContainerRight: {
    alignItems: 'flex-end',
    right: 0,
  },
  buttonHidden: {
    display: 'none',
  },
  buttonHovered: {
    opacity: 1,
  },
});
